import { UPDATE_MANAGER_STANDBY_SUCCESS } from "../Constants";

const initialState = {
  message: ""
};

export default (state = initialState, action) => {
  switch (action.type) {
    case UPDATE_MANAGER_STANDBY_SUCCESS:
      return {
        type: "Stand by Update Successfull",
        message: action.data
      };

    default:
      return state;
  }
};
